export const SLICE_PACKAGE = {
  HELP_CENTER: '@hopin-team/hopin-web-slices-help-center-organizer',
};
